/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_AccountInputs */

const cs_kn_account = /** @type {(inputs: Kn_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet KN`)
};

const en_kn_account = /** @type {(inputs: Kn_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KN account`)
};

/**
* | output |
* | --- |
* | "KN account" |
*
* @param {Kn_AccountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_account = /** @type {((inputs?: Kn_AccountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_AccountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_account(inputs)
	return cs_kn_account(inputs)
});